import styled from 'styled-components';
import { FONT_FAMILY, COLORS, DEVICES } from '@Commons';

export const Wrapper = styled.div`
  margin: 48px 0;
  width: 450px;
  display: flex;
  flex-direction: column;
  .process-list-container {
    font-size: 16px;
    margin-left: 12px;
    line-height: 26px;
    margin-top: 0;
    .list {
      list-style: disc;
      .list-item {
        margin-left: 12px;
      }
    }
  }
  @media ${DEVICES.mobileXL} {
    width: unset;
    padding: 0 24px;
    align-self: flex-start;
  }
`;
export const Subheading = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.textGrey};
`;
export const InfoBox = styled.div`
  display: flex;
  border: 1px solid rgba(72, 250, 255, 0.4);
  border-radius: 8px;
  background-color: rgba(72, 250, 255, 0.1);
  width: 450px;
  padding: 12px 16px;
  margin-bottom: 16px;

  .image-container {
    align-self: flex-start;
    margin-right: 12px;
  }
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
export const TextWrapper = styled.div`
  font-size: 14px;
  line-height: 18px;
  font-family: ${FONT_FAMILY.hellix.regular};
`;
export const ButtonWrapper = styled.div`
  margin-top: 24px;
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
